import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgChecklist = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#ECF9EC"
      fillRule="evenodd"
      d="M8.94 33.28h19.99v-28H14.94l-3 3-3 3z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="m8.94 11.25 2.98-2.99 2.98-2.98v5.97z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M26.52 23.78h-9.59v-1h9.59zM26.52 17.78h-9.59v-1h9.59zM26.52 29.78h-9.59v-1h9.59z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M14.93 27.28h-4v4h4zM14.93 21.28h-4v4h4zM14.93 15.28h-4v4h4z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m17.278 26.64-4.497 4.354-2.207-2.373.732-.681 1.513 1.626 3.763-3.645zM17.278 20.36l-4.497 4.354-2.207-2.373.732-.681 1.513 1.626 3.763-3.645zM29.911 7.939a1.1 1.1 0 0 0-.408-.079H23.15v-1h6.349"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgChecklist);

export default ForwardRef;
